import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import {  IconButton, InputAdornment } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { CalendarDays } from "lucide-react";

interface DatePickerComponentProps {
  type?: string;
  label?: string;
  onDateChange: (date: Dayjs | null) => void;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  name?: any;
  locked?: boolean;
  className?: any;
  value?: any;
  disableFuture?: boolean;
  height?: string;
  onConfirmed: (date: Dayjs | null) => void;
}

const DateTimeInput: React.FC<DatePickerComponentProps> = ({
  type,
  label,
  onDateChange,
  onConfirmed = () => {},
  name,
  className = "",
  locked = false,
  value = "",
  disableFuture = false,
  height = "",
}) => {
  const [open, setOpen] = React.useState(false); // state to control calendar

  const selectedDate = value ? dayjs(value) : null;

  const handleIconClick = () => {
    if (!locked) {
      setOpen(true);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label={label}
        onChange={(date) => {
          onDateChange(date);
        }}
        disabled={locked}
        ampm={true}
        format={
          type === "updateLead"
            ? "MM/DD/YYYY, hh:mm A, ddd"
            : "MM/DD/YYYY, hh:mm A"
        }
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onAccept={(date) => {
          onConfirmed(date);
          setOpen(false);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={selectedDate}
        timeSteps={{ minutes: 1 }}
        {...(disableFuture ? { disableFuture: true } : {})}
        slotProps={{
          textField: {
            placeholder: "Date & Time",
            name,
            disabled: locked,
            className: `   ${className}`,
            InputProps: {
              sx: {
                // Set outer container height
                "& .MuiInputBase-root": {
                  height: "35px",
                  paddingRight: "0px",
                },
                // Set actual input height & padding
                "& .MuiInputBase-input": {
                  height: height || "30px ",
                  padding: "0 8px",
                  fontSize: "14px",
                  boxSizing: "border-box",
                  borderColor: "#d1d5db",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#007070", // green
                  borderWidth: "2px",
                },
              },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    tabIndex={-1}
                    disabled={locked}
                    className="!p-[5px]"
                    onClick={handleIconClick}
                  >
                    <CalendarDays className="CalendarIcon w-5 h-5  text-gray-500" />
                  </IconButton>
                </InputAdornment>
              ),
            },
            InputLabelProps: {
              shrink: true,
              className: "text-black",
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DateTimeInput;
